<template>
  <div>
    <PageHeaderLayout>
      <div class='main-page-content'>

        <el-row class='table-search'>
          <el-col :span='24'>
            <el-form :inline='true' :model='searchCondition'>
              <el-form-item label=''>
                <el-date-picker
                  v-model='searchCondition.time_value'
                  type='daterange'
                  align='right'
                  unlink-panels
                  range-separator='至'
                  start-placeholder='开始日期'
                  end-placeholder='结束日期'
                  value-format='yyyy-MM-dd' style='width: 300px'>
                </el-date-picker>
              </el-form-item>

              <el-form-item label=''>
                <el-input v-model='searchCondition.nickname' placeholder='用户昵称' clearable></el-input>
              </el-form-item>
              <el-form-item label=''>
                <el-input v-model='searchCondition.real_ip' placeholder='登录IP' clearable></el-input>
              </el-form-item>
              <el-form-item label=''>
                <el-select v-model='searchCondition.login_method' clearable>
                  <el-option v-for='(option,index) in loginMethodOptions' :value='option.value' :label='option.label'
                             :key='index'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label=''>
                <el-select v-model='searchCondition.status' clearable placeholder='登录状态'>
                  <el-option v-for='(option,index) in loginStatusOptions' :value='option.value' :label='option.label'
                             :key='index'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type='primary' @click='handleQuery'>查询</el-button>
              </el-form-item>

            </el-form>
          </el-col>
        </el-row>
        <div class='default-table'>
          <!--    渲染表格-->
          <m-table :showIndex='true' :offset='offset' max-height='800' :tableData='dataList' :columns='columns'
                   :loading='loadingStatus' @sort-change='changeTableSort' />
          <!--    渲染分页-->
          <m-pagination :total.sync='total' :limit.sync='pagingData.page_size' :page.sync='pagingData.current_page'
                        @pagination='getList' />
        </div>
        <br/>
        <!--        图表-->
        <div class='chart-box'>
          <div>
            <el-link type='primary' icon='el-icon-refresh' @click='showChart'>登录方式饼图</el-link>
          </div>
          <div>
            <pie-chart :chart-option='chartOption'></pie-chart>
          </div>
        </div>
        <br/>
        <!--        用户登录日志分析（以用户为维度）-->
        <div class='user-analysis-box'>
          <el-row class='table-search'>
            <el-col :span='24'>
              <el-form :inline='true' :model='analysisSearchCondition'>
                <el-form-item label=''>
                  <el-date-picker
                    v-model='analysisSearchCondition.time_value'
                    type='daterange'
                    align='right'
                    unlink-panels
                    range-separator='至'
                    start-placeholder='开始日期'
                    end-placeholder='结束日期'
                    value-format='yyyy-MM-dd' style='width: 300px'>
                  </el-date-picker>
                </el-form-item>
                <el-form-item label=''>
                  <el-input v-model='analysisSearchCondition.keyword' placeholder='用户昵称/姓名/账号' clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type='primary' @click='handleAnalysisQuery'>查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div class='default-table'>
            <!--    渲染表格-->
            <m-table :showIndex='true' :offset='analysisOffset' max-height='800' :tableData='analysisDataList'
                     :columns='analysisColumns' :loading='analysisLoadingStatus' />
            <!--    渲染分页-->
            <m-pagination :total.sync='analysisTotal' :limit.sync='analysisPagingData.page_size'
                          :page.sync='analysisPagingData.current_page' @pagination='getAnalysisList' />
          </div>
        </div>
        <br/>
        <!--        部门登录日志分析（以部门为维度）-->
        <div class='dept-analysis-box'>
          <el-row class='table-search'>
            <el-col :span='24'>
              <el-form :inline='true' :model='deptAnalysisSearchCondition'>
                <el-form-item label=''>
                  <el-date-picker
                    v-model='deptAnalysisSearchCondition.time_value'
                    type='daterange'
                    align='right'
                    unlink-panels
                    range-separator='至'
                    start-placeholder='开始日期'
                    end-placeholder='结束日期'
                    value-format='yyyy-MM-dd' style='width: 300px'>
                  </el-date-picker>
                </el-form-item>
                <el-form-item label=''>
                  <el-input v-model='deptAnalysisSearchCondition.keyword' placeholder='部门名称' clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type='primary' @click='handleDeptAnalysisQuery'>查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div class='default-table'>
            <!--    渲染表格-->
            <m-table :showIndex='true' :offset='deptAnalysisOffset' max-height='800' :tableData='deptAnalysisDataList'
                     :columns='deptAnalysisColumns' :loading='deptAnalysisLoadingStatus' />
            <!--    渲染分页-->
            <m-pagination :total.sync='deptAnalysisTotal' :limit.sync='deptAnalysisPagingData.page_size'
                          :page.sync='deptAnalysisPagingData.current_page' @pagination='getDeptAnalysisList' />
          </div>
        </div>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import { mapGetters } from 'vuex'
import UserLoginLog from '@/pages/user/components/UserLoginLog'
import PieChart from '@/pages/dashboard/PieChart'

export default {
  name: 'LoginLog',
  components: {
    PieChart,
    UserLoginLog,
    PageHeaderLayout,
    ApeTable

  },
  data() {
    return {
      loadingStatus: false,
      // 搜索条件
      searchCondition: { login_method: null, status: null, nickname: null, time_value: ['2022-06-01', '2022-06-10'] },
      columns: [
        // {
        //   title: 'ID',
        //   value: 'id',
        //   width: 80
        // },
        {
          title: '昵称',
          value: 'nickname',
          width: 120,
          sortable: 'custom'
        },
        {
          title: '登录IP',
          value: 'real_ip',
          width: 100,
          sortable: 'custom'
        },
        {
          title: '登录时间',
          value: 'login_at',
          width: 140
        },
        {
          title: '登录状态',
          value: 'status_alias',
          width: 100
        },
        {
          title: '登录方式',
          value: 'login_method_alias',
          width: 100
        },
        {
          title: '失败原因',
          value: 'fail_reason',
          width: 200
        },
        {
          title: '登录有效期',
          value: 'login_expire_at',
          width: 140
        },
        {
          title: '设备',
          value: 'device',
          width: 100
        },
        {
          title: '浏览器',
          value: 'browser',
          width: 100
        },
        {
          title: '系统',
          value: 'platform',
          width: 100
        },
        {
          title: '退出时间',
          value: 'logout_at',
          width: 100
        },
        {
          title: '记录时间',
          value: 'created_at',
          width: 140
        },
        {
          title: '更新时间',
          value: 'created_at',
          width: 140
        }
      ],
      // 分页信息
      pagingData: {
        current_page: 1,
        page_size: 15
      },
      total: 0,
      // 分页的offset,序号列使用
      offset: 0,
      dataList: [],
      orderSort: { id: 'desc' },
      loginMethodOptions: [
        { label: '账号登录', value: 1 },
        { label: '扫码登录', value: 2 },
        { label: '授权登录', value: 3 }
      ],
      loginStatusOptions: [
        { label: '成功', value: 1 },
        { label: '失败', value: 0 }
      ],
      chartOption: {},
      // ===== 用户登录日志分析（以用户为维度）=====
      analysisLoadingStatus: false,
      // 分析搜索条件
      analysisSearchCondition: { keyword: null, time_value: null },
      // 分析表格列
      analysisColumns: [
        {
          title: '昵称',
          value: 'nickname',
          width: 140
        },
        {
          title: '姓名',
          value: 'name',
          width: 140
        },
        {
          title: '账号',
          value: 'username',
          width: 150
        },
        {
          title: '手机号',
          value: 'mobile',
          width: 120
        },
        {
          title: '工号',
          value: 'job_number',
          width: 100
        },
        {
          title: '归属部门',
          value: 'dept_name',
          width: 260
        },
        {
          title: '登录次数',
          value: 'login_count',
          width: 100
        },
        {
          title: '成功次数',
          value: 'success_count',
          width: 100
        },
        {
          title: '失败次数',
          value: 'fail_count',
          width: 100
        },
        {
          title: '最近登录时间',
          value: 'last_login_at',
          width: 160
        }
      ],
      // 分析分页信息
      analysisPagingData: {
        current_page: 1,
        page_size: 15
      },
      analysisTotal: 0,
      // 分页的offset,序号列使用
      analysisOffset: 0,
      analysisDataList: [],
      // ===== 部门登录日志分析（以部门为维度）=====
      deptAnalysisLoadingStatus: false,
      // 部门分析搜索条件
      deptAnalysisSearchCondition: { keyword: null, time_value: null },
      // 部门分析表格列
      deptAnalysisColumns: [
        {
          title: '部门',
          value: 'dept_name',
          width: 200
        },
        {
          title: '部门路径',
          value: 'dept_path',
          width: 260
        },
        {
          title: '登录次数',
          value: 'login_count',
          width: 100
        },
        {
          title: '成功次数',
          value: 'success_count',
          width: 100
        },
        {
          title: '失败次数',
          value: 'fail_count',
          width: 100
        },
        {
          title: '最近登录时间',
          value: 'last_login_at',
          width: 160
        }
      ],
      // 部门分析分页信息
      deptAnalysisPagingData: {
        current_page: 1,
        page_size: 15
      },
      deptAnalysisTotal: 0,
      // 分页的offset,序号列使用
      deptAnalysisOffset: 0,
      deptAnalysisDataList: [],
      option: {
        title: {
          text: '用户登录方式',
          subtext: '2023-12-01 ~ 2023-12-22',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '登录方式',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 1048, name: '账号登录' },
              { value: 735, name: '授权登录' },
              { value: 580, name: '扫码登录' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }

    }
  },
  computed: {
    ...mapGetters(['userPermissions'])
  },
  methods: {
    handleQuery() {
      this.pagingData.current_page = 1
      this.getList()
      this.showChart()
    },
    async getList() {
      this.dataList = []
      this.loadingStatus = true
      let searchCondition = this.handleSearchCondition()
      // 合并
      Object.assign(searchCondition, this.pagingData, { order: this.orderSort })
      let { list, pages } = await this.$api.getUserLoginLog(searchCondition)
      this.dataList = this.formatDataList(list)
      this.total = pages.total
      this.offset = pages.offset
      this.pagingData.current_page = pages.current_page
      this.pagingData.page_size = pages.page_size
      this.loadingStatus = false
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.nickname) {
        condition.nickname = this.searchCondition.nickname
      }
      if (this.searchCondition.login_method) {
        condition.login_method = this.searchCondition.login_method
      }
      if (this.searchCondition.status !== null && this.searchCondition.status !== '') {
        condition.status = this.searchCondition.status
      }
      if (this.searchCondition.real_ip) {
        condition.real_ip = this.searchCondition.real_ip
      }
      if (this.searchCondition.time_value) {
        condition.start_time = this.searchCondition.time_value[0]
        condition.end_time = this.searchCondition.time_value[1]
      }
      return condition
    },
    formatDataList(list) {
      return list.map(item => {
        if (item.status_alias) {
          if (item.status === 1) {
            item.status_alias = '<span class="login-status-tag login-status-success">成功</span>'
          } else if (item.status === 0) {
            item.status_alias = '<span class="login-status-tag login-status-fail">失败</span>'
          }
        }
        return item
      })
    },
    changeTableSort({ prop, order }) {
      let orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getList()

    },
    async showChart() {
      //请求数据
      let searchCondition = this.handleSearchCondition()
      let { option } = await this.$api.getUserLoginLogChartData(searchCondition)
      this.chartOption = { ...this.option }
      //筛选条件
      this.chartOption.title.subtext = option.subtext
      this.chartOption.series[0].data = option.data || []
    },
    // 用户登录日志分析
    handleAnalysisQuery() {
      this.analysisPagingData.current_page = 1
      this.getAnalysisList()
    },
    async getAnalysisList() {
      this.analysisDataList = []
      this.analysisLoadingStatus = true
      let searchCondition = this.handleAnalysisSearchCondition()
      // 合并
      Object.assign(searchCondition, this.analysisPagingData)
      let { list, pages } = await this.$api.getUserLoginLogUserAnalysis(searchCondition)
      this.analysisDataList = list
      this.analysisTotal = pages.total
      this.analysisPagingData.current_page = pages.current_page
      this.analysisPagingData.page_size = pages.page_size
      // 接口未返回 offset，自行计算序号偏移
      this.analysisOffset = (pages.current_page - 1) * pages.page_size
      this.analysisLoadingStatus = false
    },
    // 处理分析搜索条件
    handleAnalysisSearchCondition() {
      let condition = {}
      if (this.analysisSearchCondition.keyword) {
        condition.keyword = this.analysisSearchCondition.keyword
      }
      if (this.analysisSearchCondition.time_value) {
        condition.start_time = this.analysisSearchCondition.time_value[0]
        condition.end_time = this.analysisSearchCondition.time_value[1]
      }
      return condition
    },
    // 部门登录日志分析
    handleDeptAnalysisQuery() {
      this.deptAnalysisPagingData.current_page = 1
      this.getDeptAnalysisList()
    },
    async getDeptAnalysisList() {
      this.deptAnalysisDataList = []
      this.deptAnalysisLoadingStatus = true
      let searchCondition = this.handleDeptAnalysisSearchCondition()
      // 合并
      Object.assign(searchCondition, this.deptAnalysisPagingData)
      let { list, pages } = await this.$api.getUserLoginLogDeptAnalysis(searchCondition)
      this.deptAnalysisDataList = this.formatDeptAnalysisDataList(list)
      this.deptAnalysisTotal = pages.total
      this.deptAnalysisPagingData.current_page = pages.current_page
      this.deptAnalysisPagingData.page_size = pages.page_size
      // 接口未返回 offset，自行计算序号偏移
      this.deptAnalysisOffset = (pages.current_page - 1) * pages.page_size
      this.deptAnalysisLoadingStatus = false
    },
    // 处理部门分析搜索条件
    handleDeptAnalysisSearchCondition() {
      let condition = {}
      if (this.deptAnalysisSearchCondition.keyword) {
        condition.keyword = this.deptAnalysisSearchCondition.keyword
      }
      if (this.deptAnalysisSearchCondition.time_value) {
        condition.start_time = this.deptAnalysisSearchCondition.time_value[0]
        condition.end_time = this.deptAnalysisSearchCondition.time_value[1]
      }
      return condition
    },
    // 格式化部门分析数据（补充部门路径）
    formatDeptAnalysisDataList(list) {
      return list.map(item => {
        if (item.dept_arr && item.dept_arr.length) {
          item.dept_path = item.dept_arr.join('、')
        } else {
          item.dept_path = item.dept_name || ''
        }
        return item
      })
    }
  },
  created() {
    //默认时间
    let date = new Date()
    let currentDay = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    let monthFirstDay = `${date.getFullYear()}-${date.getMonth() + 1}-01`
    this.searchCondition.time_value = [monthFirstDay, currentDay]
    this.analysisSearchCondition.time_value = [monthFirstDay, currentDay]
    this.deptAnalysisSearchCondition.time_value = [monthFirstDay, currentDay]
    this.handleQuery()
    this.handleAnalysisQuery()
    this.handleDeptAnalysisQuery()
  }
}
</script>

<style scoped>
.chart-box {
  width: 50%;

}
</style>
<style>
.login-status-tag {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  line-height: 20px;
}
.login-status-success {
  background-color: #f0f9eb;
  border: 1px solid #e1f3d8;
  color: #67c23a;
}
.login-status-fail {
  background-color: #fef0f0;
  border: 1px solid #fde2e2;
  color: #f56c6c;
}
</style>
